module.exports = __webpack_public_path__ + "7699a6409cf1a4d17a63ad2682e61ba1.MP3";